export default [
    {
        path: '/work-load-balance-subperiod',
        name: 'work-load-balance-subperiod',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Balanço de Atribuição por Subperíodo',
            icon: 'mdi-scale-balance',
            breadcrumbs: [
                { text: 'Balanço de Atribuição por Subperíodo', disabled: true }
            ]
        }
    }
]
